export default __webpack_public_path__ + "static/media/img-0350-central-african-full-face.52dc4bd3.png";